import $ from 'domtastic';
import { events, disableScroll } from '../utils';

class Modal {
  constructor(identifier) {
    if (!identifier) return;
    this.identifier = identifier;
    this.cacheDom();
    if (!this.$root[0]) return;
    this.bindEvents();
  }

  cacheDom() {
    this.$root = $('.js-modal-root');
    this.$close = $('.js-modal-close');
  }

  bindEvents() {
    this.$close.on('click', (event) => {
      this.manualClose(event);
    });

    events.on('modalopen', (event) => {
      if (!event.identifier || !this.isIdentifier(event.identifier)) return;
      this.open();
    });

    events.on('modalclose', (event) => {
      this.close(event);
    });
  }

  isIdentifier(identifier) {
    if (identifier !== this.identifier) return false;
    return true;
  }

  manualClose(event) {
    const $target = $(event.target);
    if (!$target.hasClass('js-modal-close')) return;
    const $targetRoot = $target.closest('.js-modal-root');
    const identifier = $targetRoot.attr('data-identifier');
    if (!identifier || !this.isIdentifier(identifier)) return;
    const type = $target.hasClass('button') ? 'button' : 'background';
    events.emit('modalclose', { type, identifier });
  }

  open() {
    disableScroll.lock();
    this.$root.removeClass('-hidden');
    this.$root.addClass('-visible');
  }

  close(event) {
    this.$root.removeClass('-visible');
    this.$root.off().on('transitionend', () => {
      this.$root.addClass('-hidden');
      events.emit('modalclosed', event);
      disableScroll.release();
    });
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./components/Modal.js